import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './CookieBanner.module.css';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Pokaż baner tylko jeśli użytkownik jeszcze nie zamknął
    const accepted = localStorage.getItem('cookie_notice');
    if (!accepted) {
      // Małe opóźnienie żeby nie migał przy pierwszym renderze
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_notice', '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="dialog" aria-label="Informacja o cookies">
      <div className={styles.inner}>
        <div className={styles.text}>
          <span className={styles.icon}>🍪</span>
          <p>
            Ta strona używa <strong>wyłącznie niezbędnych plików cookie</strong> do obsługi logowania (token JWT w localStorage).
            Nie używamy cookies reklamowych ani śledzących. Korzystając ze strony, akceptujesz tę politykę.{' '}
            <Link to="/prywatnosc" className={styles.link}>Dowiedz się więcej</Link>
          </p>
        </div>
        <button className={styles.btn} onClick={accept}>
          Rozumiem
        </button>
      </div>
    </div>
  );
}
